import { render, staticRenderFns } from "./OverallPerformance.vue?vue&type=template&id=14a74234&"
import script from "./OverallPerformance.vue?vue&type=script&lang=ts&"
export * from "./OverallPerformance.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports